<template>
  <div id="foot" class="wrap">
    <div class="mobile" v-if="isMobile">
      <div class="text">
        <div>The materials on this website are for illustration and discussion purposes only and do not constitute an offering. An offering may be made only by delivery of a confidential offering memorandum to appropriate investors.</div>
        <div class="fw500">PAST PERFORMANCE IS NO GUARANTEE OF FUTURE RESULTS.</div>
      </div>
      <div class="Copyright">
        © {{new Date().getFullYear()}} Evolutionary Capital (Singapore) Pte Ltd. All Rights Reserved.
      </div>
    </div>
    <!-- webPc端 -->
    <div class="web" v-else>
      <div class="foot">
        <div class="text">
          <div>The materials on this website are for illustration and discussion purposes only and do not constitute an offering. An offering may be made only by delivery of a confidential offering memorandum to appropriate investors.</div>
          <div class="center">PAST PERFORMANCE IS NO GUARANTEE OF FUTURE RESULTS.</div>
        </div>
        <div class="Copyright">
          © {{new Date().getFullYear()}} Evolutionary Capital (Singapore) Pte Ltd. All Rights Reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/utils/utils";
export default {
  name: "footerBar",
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    this.isMobile = utils.isMobile();
  }
};
</script>

<style scoped lang="less">
.mobile {
  height: 920px;
  background: #000000;

  .text {
    padding: 92px;
    font-weight: 400;
    font-size: 55px;
    color: #FFFFFF;
    line-height: 78px;
    text-align: justify;

    .fw500 {
      margin-top: 46px;
      font-weight: 500;
    }
  }

  .Copyright {
    font-size: 52px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 70px;
    text-align: center;
    padding: 69px 0 92px;
    border-top: 1px solid rgba(255, 255, 255, 0.3);

    a {
      display: block;
    }
  }
}

.web {
  img {
    width: 100%;
    height: auto;
  }

  .foot {
    width: 100%;
    height: 187px;
    background: #333333;

    .text {
      padding: 40px 105px 20px;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 22px;
    }
  }

  .model {
    padding: 0 240px 60px;
    justify-content: space-around;

    .itm {
      .name {
        font-size: 16px;
        font-weight: normal;
        color: #ffffff;
        padding-bottom: 28px;
        position: relative;

        &::after {
          content: "";
          width: 36px;
          height: 3px;
          background: rgba(255, 255, 255, 0.4);
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }

      li {
        font-size: 16px;
        font-weight: normal;
        color: #ffffff;
        line-height: 22px;
        margin-top: 20px;
      }

      .contact {
        margin-bottom: 30px;

        img {
          width: 32px;
          height: 32px;
        }

        span {
          font-size: 16px;
          font-weight: normal;
          color: #ffffff;
          line-height: 22px;
          margin: 0 12px;
        }

        .tel {
          font-size: 24px;
          font-weight: normal;
          color: #ffffff;
          line-height: 34px;
        }

        .email {
          font-size: 16px;
          font-weight: normal;
          color: #ffffff;
          line-height: 22px;
        }
      }
    }
  }

  .Copyright {
    font-size: 15px;
    font-weight: normal;
    color: #FFFFFF;
    text-align: center;
    padding: 20px 0 40px;
    border-top: 2px solid rgba(255, 255, 255, 0.3);

    a {
      text-decoration: underline;
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterBar.vue